/**
 * Atribución de los formularios de lead de la web (2026-10-21).
 *
 * Al cargar la web se apunta EN MEMORIA la página de entrada (solo las claves utm_* y de clic
 * de su query) y el referente externo. No se escribe nada en el navegador (ni cookies ni
 * localStorage), así que no necesita consentimiento: viaja con el envío del formulario como un
 * campo más. Al navegar dentro de la SPA la URL pierde los UTM; por eso se toma al arrancar.
 * El core lo guarda como evento «touch» del runtime de analítica (AnalyticsEvent), fuera de las notas.
 */
const ALLOWED = [
  'utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id',
  'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid', 'li_fat_id',
];

export const cleanUrl = (href) => {
  try {
    const url = new URL(href);
    const kept = new URLSearchParams();
    ALLOWED.forEach((key) => {
      const value = url.searchParams.get(key);
      if (value) kept.set(key, value.slice(0, 255));
    });
    const query = kept.toString();
    return `${url.origin}${url.pathname}${query ? `?${query}` : ''}`;
  } catch (e) {
    return '';
  }
};

const externalReferrer = () => {
  try {
    if (!document.referrer) return '';
    const ref = new URL(document.referrer);
    return ref.host === window.location.host ? '' : `${ref.origin}/`;
  } catch (e) {
    return '';
  }
};

const LANDING = typeof window === 'undefined'
  ? { landing_url: '', referrer: '' }
  : { landing_url: cleanUrl(window.location.href), referrer: externalReferrer() };

/** Lo que se manda en `attribution` con cada formulario de lead. */
export const leadAttribution = () => ({ ...LANDING, storage_consent: false });

export default leadAttribution;
